import { useQuery } from "@tanstack/react-query";
import { fetchCharityCatalogue } from "@/api/charity";

// Both views share ONE query on purpose: the selector's loading state has to cover the default
// too, or Step 4 paints "Choose a cause" for a frame before the default arrives.
const CATALOGUE_QUERY = {
  queryKey: ["charity", "causes"],
  queryFn: fetchCharityCatalogue,
  staleTime: 1000 * 60 * 5, // 5 minutes
};

/** The cause catalogue. Identical for every client, so it caches indefinitely within a session. */
export function useCharityCauses() {
  return useQuery({ ...CATALOGUE_QUERY, select: (d) => d.causes });
}

/** The platform default Step 4 pre-selects, already filtered to the catalogue. */
export function useDefaultCauseSelection() {
  return useQuery({ ...CATALOGUE_QUERY, select: (d) => d.defaultSelection });
}
